import { useEffect, useState } from "react";
import { Box } from "@mui/material";

const COLORS = ["#818cf8", "#34d399", "#fbbf24", "#f87171", "#22d3ee", "#fb923c", "#a78bfa"];

export default function Confetti({ trigger, pieces = 90, onDone }) {
  const [bits, setBits] = useState([]);

  useEffect(() => {
    if (!trigger) return undefined;
    const arr = Array.from({ length: pieces }, (_, i) => ({
      id: `${trigger}-${i}`,
      left: Math.random() * 100,
      delay: Math.random() * 0.25,
      duration: 2 + Math.random() * 1.6,
      color: COLORS[i % COLORS.length],
      rotation: Math.floor(Math.random() * 360),
      width: 6 + Math.random() * 6,
      height: 8 + Math.random() * 8,
      drift: -120 + Math.random() * 240,
      spin: 360 + Math.floor(Math.random() * 720),
    }));
    setBits(arr);
    const t = setTimeout(() => {
      setBits([]);
      if (onDone) onDone();
    }, 4200);
    return () => clearTimeout(t);
  }, [trigger, pieces, onDone]);

  if (!bits.length) return null;

  return (
    <Box
      sx={{
        position: "fixed",
        inset: 0,
        pointerEvents: "none",
        zIndex: 9999,
        overflow: "hidden",
      }}
    >
      <style>{`
        @keyframes bidrl-confetti-fall {
          0%   { transform: translate3d(0, -10vh, 0) rotate(0deg);                opacity: 1; }
          85%  { opacity: 1; }
          100% { transform: translate3d(var(--drift), 110vh, 0) rotate(var(--spin)); opacity: 0; }
        }
      `}</style>
      {bits.map((p) => (
        <Box
          key={p.id}
          sx={{
            position: "absolute",
            top: 0,
            left: `${p.left}%`,
            width: `${p.width}px`,
            height: `${p.height}px`,
            bgcolor: p.color,
            borderRadius: "1px",
            transform: `rotate(${p.rotation}deg)`,
            "--drift": `${p.drift}px`,
            "--spin": `${p.spin}deg`,
            animation: `bidrl-confetti-fall ${p.duration}s cubic-bezier(.22,.7,.4,1) ${p.delay}s forwards`,
            willChange: "transform, opacity",
          }}
        />
      ))}
    </Box>
  );
}
